import React from 'react'
import '../ProfilePostsStories/PostsStoriesBottom.css'

const PostsStoriesBottom = () => {
  return (
   
    <div className='post-stories-bottom'>
        <div className='post-stories-bottom-box'>
            <div className='add-more-stories d-flex align-items-center mb-4 gap-2'>
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.53846 3.75098C2.13043 3.75098 1.73912 3.91307 1.4506 4.20158C1.16209 4.49011 1 4.88142 1 5.28945V19.905C1 20.313 1.16209 20.7044 1.4506 20.9929C1.73912 21.2813 2.13043 21.4435 2.53846 21.4435H19.4615C19.8695 21.4435 20.2609 21.2813 20.5494 20.9929C20.8378 20.7044 21 20.313 21 19.905V5.28945C21 4.88142 20.8378 4.49011 20.5494 4.20158C20.2609 3.91307 19.8695 3.75098 19.4615 3.75098H16.3846" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.61572 1.44336V6.05879" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.3843 1.44336V6.05879" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.61572 3.75098H13.308" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.8461 12.9824H7.15381" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 9.13574V16.8281" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span>Posts</span>
            </div>
            <div className='post-stories-box'>
                <div className='post-stories-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>iamtom  <span>9h</span></h5>
                        <p>Looking to send money to someone! </p>
                    </div>
                </div>
            </div>
            <div className='post-stories-box '>
                <div className='post-stories-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>iamtom <span>9h</span></h5>
                        <p>Looking to send money to someone!  </p>
                    </div>
                </div>
                <div className='two-img-box'>
                    <ul className='d-flex flex-wrap '>
                        <li className='img-box'></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PostsStoriesBottom
